export function getImageUrl(image, apiUrl) {
  if (!image) return "";

  if (/^https?:\/\//i.test(image)) {
    return image;
  }

  const baseUrl = (apiUrl || "").replace(/\/+$/, "");
  const imagePath = String(image).startsWith("/")
    ? image
    : `/${image}`;

  return `${baseUrl}${imagePath}`;
}